import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 scroll-mt-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-4">移动阅读</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{appInfo.title}</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">{appInfo.desc}</p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
              {appInfo.features.map((f, i) => (
                <span key={i} className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-background-50 text-foreground-700 rounded-full border border-background-300 whitespace-nowrap">
                  <i className="ri-check-line text-accent-500"></i>
                  {f}
                </span>
              ))}
            </div>
            <div className="flex items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 text-background-50 font-semibold text-sm rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line"></i>
                Android 下载
              </span>
              <span className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 text-background-50 font-semibold text-sm rounded-lg hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line"></i>
                iOS 下载
              </span>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[260px] lg:max-w-[300px]">
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden shadow-lg">
              <img src={appInfo.image} alt="古古漫画网移动端" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}